export const ALL_CATEGORIES_LOADING = "ALL_CATEGORIES_LOADING";
export const ALL_CATEGORIES_SUCCESS = "ALL_CATEGORIES_SUCCESS";
export const ALL_CATEGORIES_FAIL = "ALL_CATEGORIES_FAIL";
